import { cn } from "@/lib/utils";

export type DrillStatus = "new" | "progress" | "done";

interface DrillStatusBadgeProps {
  status: DrillStatus;
  className?: string;
}

const statusConfig = {
  new: {
    label: "New",
    className: "drill-status-new",
  },
  progress: {
    label: "In Progress", 
    className: "drill-status-progress",
  },
  done: {
    label: "Completed",
    className: "drill-status-done",
  },
};

export function DrillStatusBadge({ status, className }: DrillStatusBadgeProps) {
  const config = statusConfig[status];
  
  return (
    <span className={cn(config.className, className)}>
      {config.label}
    </span>
  );
}